import { useLocale } from 'next-intl';
import localeRoutes from '@/messages/localeRoutes.json';
import routesData from '@/src/routesData.local.json';

export const getLocaleRoute = (path: string, locale: string) => {
  const routeData = routesData[path as keyof typeof routesData] || false;
  if (routeData && routeData[('slug-'+locale) as keyof typeof routeData]) {
    return String(routeData[('slug-'+locale) as keyof typeof routeData]);
  }
  const translations = localeRoutes[path as keyof typeof localeRoutes] ?? {
    [locale]: path,
  };
  return translations[locale as keyof typeof translations] ?? path;
};

export const useLocaleRoutes = () => {
  const locale = useLocale();
  return (path?: string) => {
    if (!path) {
      if (locale === process.env.NEXT_PUBLIC_DEFAULT_LOCALE) {
        return '';
      } else {
        return `/${locale}`;
      }
    }
    return getLocaleRoute(path, locale);
  };
};

export const RoutesRepeater = (locales: string[]) => {
  return (template: string, replacements: string[]) => {
    let result = {} as any;
    locales.forEach((locale) => {
      let temp = template;
      replacements.forEach((rep) => {
        temp = temp.replace(`{${rep}}`, getLocaleRoute(rep, locale));
      });
      result[locale] = temp;
    });
    return result;
  };
};
